import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService, UtilityService } from '@mono-repo/util';
import { ConfigService } from '../../config.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-service-not-available',
  templateUrl: './service-not-available.component.html',
})
export class ServiceNotAvailableComponent implements OnInit {
  @HostBinding('class') class = 'dt-error dt-c-interactive-dialog';

  public errorMessage: string;

  constructor(
    private translateService: TranslateService,
    public utilityService: UtilityService,
    private readonly configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.translateService.setCurrentModuleTranslation('error');
    this.route.queryParams.subscribe({
      next: (response) => {
        this.errorMessage = response['message'];
      },
    });
  }

  /**
   * Gets the config via the config service, AND ONLY IF THE CONFIG IS AVAILABLE, navigates to /cockpit.
   *
   * @remarks
   * Instead of using the error{} block after next{} block, we just check if the response "exists" inside the next{} block since loadConfig() returns null if it doesn't.
   * This behavior of loadConfig() is intentional, to prevent the app from stopping working if the config is not available.
   *
   * No unsubscribe() is needed since the subscription is automatically destroyed when window.location.reload() is called.
   *
   */
  public getConfigAndNavigateToCockpit(): void {
    // Only loads the config if it isn't already loaded.
    if (!this.configService.getConfig()) {
      this.configService.loadConfig().subscribe({
        next: (response) => {
          // Only navigates if the response isn't null.
          if (response) {
            this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
              window.location.reload(); // Needed to reload the app to apply the new config. Otherwise, app.module.ts will be incorrectly initalized because of the missing config params.
            });
            this.router.navigate([`/${this.configService.getConfig()?.initialRoute || '/'}`]);
          }
        },
      });
    } else {
      // If the config is already loaded, just navigate back.
      this.router.navigate([`/${this.configService.getConfig()?.initialRoute || '/'}`]);
    }
  }
}
